import { render } from "preact";
import "./index.css";
import App from "./App";

render(<App />, document.getElementById("app")!);
